import React from 'react';
import RefreshIcon from "../../assets/icons/RefreshIcon";
import SilverButton from "./SilverButton";
import Translate from "../../components/Translate";
import colors from "../../utils/Colors";


const ResetButton = ({
                         onClick,
                         height = 40,
                         width = 40 ,
                         children,
                         variant = 'default',
                         disabled = false,
                         showText = true,
                         style = {}
                    }) => {
    return (
        <SilverButton
            width={width}
            height={height}
            onClick={onClick}
            variant={variant}
            disabled={disabled}
            styles={style}
        >
            <div style={{
                display: 'flex',
                gap: '10px',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: 'transparent',
                height: '100%',
                width: '100%',
                fontSize: '14px',
                opacity: disabled ? 0.5 : 1,
            }}>
                <RefreshIcon
                    width={20}
                    height={20}
                    stroke="currentColor"
                />
                {showText && <Translate text={'resetFilters'}/>}
                {children}
            </div>
        </SilverButton>
    );
};

export default ResetButton;



// WEBPACK FOOTER //
// ./src/components-new/buttons/ResetButton.jsx